export default __webpack_public_path__ + "static/media/Policies.5c06c5a6.pdf";